export default "<div [class]=\"projectName\" style=\"height: 100%;\">\n  <router-outlet></router-outlet>\n</div>\n\n"